import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: '[app-status-text-group]',
  templateUrl: './status-text-group.component.html',
  styleUrls: ['./status-text-group.component.scss']
})
export class StatusTextGroupComponent implements OnInit {

  @Input() status: string;
  @Input() topText: string;
  @Input() userInfo: string;
  @Input() bottomText: string;

  constructor() { }

  ngOnInit() {
    if (this.userInfo == ' ') {
      this.userInfo = null;
    }
  }

}
